<template>
  <section class="tramite">
    <h3 class="title text-center">{{ $t('tramite.title') }}</h3>
    <div class="form-group">
      <label>{{ $t('BUSCAR_TRAMITE') }}</label>
      <input
        type="search"
        class="form-control"
        v-model="search"
        v-bind:placeholder="$t('ESCRIBIR_TRAMITE')">
    </div>
    <div class="grid cols-2">
      <div v-for="(items, key) in documentosFilter">
        <h4 class="title">{{ key }}</h4>
        <ul>
          <li v-for="item in items">
            {{ item.nombre }}<br>
            <span v-if="item.descripcion"><small><em>{{ item.descripcion }}</em></small><br></span>
            <span class="links">
              <strong>{{ $t('PRECIO') }} {{ item.monto[0].monto || 0 }} Bs.</strong> |
              <a :href="item.url" target="_blank">{{ $t('VER_DETALLES') }}</a> |
              <router-link to="/solicitud">{{ $t('SOLICITAR_APOSTILLA') }}</router-link>
            </span>
            <br><br>
          </li>
        </ul>
      </div>
    </div>
  </section>
</template>

<script>
import Documentos from '@/components/pages/mixins/documentos';

export default {
  mixins: [ Documentos ],
  mounted () {
    this.getDocumentos(true);
  },
  data () {
    return {
      documentos: [],
      search: ''
    };
  },
  computed: {
    documentosFilter () {
      let documentos = {};
      // if (this.search.toLowerCase() !== '') {
      for (let key in this.documentos) {
        let items = this.documentos[key].filter(item => {
          return item.nombre.toLowerCase().indexOf(this.search.toLowerCase()) > -1 ||
                item.entidad_nombre.toLowerCase().indexOf(this.search.toLowerCase()) > -1;
        });

        if (items.length) {
          documentos[key] = items;
        }
      }
      // }
      return documentos;
    }
  }
};
</script>

<style lang="scss">
.links {
  font-size: 0.8rem;
  margin-bottom: 15px;

  a {
    font-size: 0.8rem;
  }
}
@media (max-width: 768px) {
  .tramite .grid {
    h4 {
      margin: 25px 0 10px;
      text-align: center;
    }
    ul {
      margin: 0;
      padding: 0 15px;
    }
    grid-template-columns: 1fr;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/Tramite.vue